import React, { useEffect, useState } from "react";
import style from "./LoadableImage.module.css";

export const LoadableImage = ({
  src,
  alt,
  className = "",
  width,
  height,
  aspectRatio,
  imageStyle,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
  }, [src]);

  const ratio =
    aspectRatio || (width && height ? `${width} / ${height}` : undefined);

  return (
    <div
      className={style.mediaFrame}
      style={{ aspectRatio: ratio }}
      aria-busy={!isLoaded}
    >
      {!isLoaded && <div className={style.skeleton} aria-hidden="true" />}
      <img
        {...props}
        className={`${style.image} ${isLoaded ? style.loaded : ""} ${className}`}
        src={src}
        alt={alt}
        width={width}
        height={height}
        style={imageStyle}
        onLoad={() => setIsLoaded(true)}
        onError={() => setIsLoaded(true)}
      />
    </div>
  );
};
